import React, { useMemo } from 'react'
import { rmaLRPage } from '../constant'
import Confirmation from './Confirmation'
import Detail from './Detail'

const LifetimeReplacementModule = ({ data }) => {
  const { type } = { ...data }
  const Component = useMemo(() => {
    if (type === rmaLRPage.confirmation) return Confirmation

    return Detail
  }, [type])

  return (
    <Component moduleData={data} />
  )
}

export default LifetimeReplacementModule
